/* eslint-disable */
import man1 from '../assets/svg/testimonials/Jordan Hunsaker.jpeg'
import man2 from '../assets/svg/testimonials/Will Hanson.jpeg'
import man3 from '../assets/svg/testimonials/Zain Ali.jpeg'
import man4 from '../assets/svg/testimonials/Maxim Yasochka.jpeg'
import man5 from '../assets/svg/testimonials/Zander Laurent.jpeg'

export const testimonialsData = [
    {
        id: 1,
        name: 'Jordan Hunsaker',
        title: 'Sales Manager',
        text: "I had a perfect consultation call with this developer, and I must say his technical skills in React, Next, Node, and TypeScript are truly impressive. Perfect!.",
        image: man1
    },
    {
        id: 2,
        name: 'Will Hanson',
        title: 'CTO',
        text: "It was a pleasure collaborating with Oleh. He showcased utmost professionalism and demonstrated the acumen of an experienced entrepreneur. Really Excellent!!!",
        image: man2
    },
    {
        id: 3,
        name: ' Zain Ali',
        title: 'Design Leader',
        text: "Oleh did a great job as per usual. He is very quick to understand the bigger picture goals and helped me understand the different options to achieving that.",
        image: man3
    },
    {
        id: 4,
        name: 'Maxim Yasochka',
        title: 'Director of engineering',
        text: "Oleh did an excellent job and delivered the project exactly as required. He was a great communicator!",
        image: man4
    },
    {
        id: 5,
        name: 'Zander Laurent',
        title: 'Director of Product at inside Real Estate',
        text: "Oleh did a fantastic job! He has a great eye for design. He also delivers on time. And he went above and beyond for me while making edits.",
        image: man5
    },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

